import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { LOGIN_MUTATION } from "../graphql/mutations";
import ShareStockLogo from "../Components/Pictures/ShareStockLogo";
import Cookies from "js-cookie";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, { loading }] = useMutation(LOGIN_MUTATION);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success",
  );

  const handleCreateAccount = () => {
    navigate("/signup");
  };

 const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();
  try {
    const { data } = await login({ variables: { email, password } });
    console.log("data: ", data);

    if (data?.login.token) {
      // Set the token as an HTTP-only cookie using `js-cookie`
      Cookies.set("authToken", data.login.token, {
        secure: true, // Ensures the cookie is only sent over HTTPS
        sameSite: "Strict", // Prevents CSRF attacks
        expires:  1, // Cookie expires in 1 day (adjust as needed)
      });

      setSnackbarMessage("Login successful!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      navigate("/landing"); // Navigate to the home page or any other page after login
    }
  } catch (e) {
    setSnackbarMessage("Login failed. Please check your email and password.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};

  const handleSnackbarClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };


  // If we are logged in, automatically route to the landing page
  if (Cookies.get("authToken")!!) {
    navigate('/landing');
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 8,
      }}
    >
      <ShareStockLogo />
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to Sharestock!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Please sign in below.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
          disabled={loading}
        >
          {loading ? "Signing In..." : "Sign In"}
        </Button>
        {/* Create Account Button */}
        <Button
          variant="text"
          color="primary"
          onClick={handleCreateAccount}
          sx={{
            textTransform: "none", // Optional: Avoid all-caps text
          }}
        >
          Create Account
        </Button>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set the position to the bottom right
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default LoginPage;
